module.exports = __webpack_public_path__ + "img/scenicSpot.589401fa.svg";